export default {
  tabs: {
    home: "Inicio",
    browse: "Explorar",
    trends: "Tendencias",
    myPicks: "Mis picks",
    leagues: "Ligas",
  },
  common: {
    viewAll: "Ver todo",
    operator: "Operador",
    priceComparison: "Comparación de cuotas",
    linematePlus: "Linemate+",
    joinLinematePlus: "Unirse a Linemate+",
    actions: {
      apply: "Aplicar",
      clearAll: "Borrar todo",
      gotIt: "Entendido",
      cancel: "Cancelar",
      close: "Cerrar",
      openSettings: "Abrir configuración",
      continue: "Continuar",
      claim: "Reclamar",
      visitPartner: "Visitar socio",
      alreadyHaveAccount: "Ya tengo una cuenta",
      edit: "Editar",
      done: "Listo",
      save: "Guardar",
      changePassword: "Cambiar contraseña",
      submit: "Enviar",
      resendCode: "Reenviar código",
      getStarted: "Comenzar",
      continueWithApple: "Continuar con Apple",
      continueWithGoogle: "Continuar con Google",
      continueWithEmail: "Continuar con correo",
      selectLocation: "Seleccionar una ubicación",
      showMore: "Mostrar más",
    },
    labels: {
      player: "Jugador",
      team: "Equipo",
      firstName: "Nombre",
      lastName: "Apellido",
      username: "Nombre de usuario",
      email: "Correo electrónico",
      password: "Contraseña",
      emailAddress: "Correo electrónico",
      confirmPassword: "Confirmar contraseña",
      code: "Código",
      preferredOdds: "Cuotas preferidas",
    },
    placeholders: {
      emailAddress: "Ingresa tu correo electrónico...",
      password: "Ingresa tu contraseña...",
    },
    errors: {
      genericTryAgainLater: "Algo salió mal. Vuelve a intentarlo más tarde.",
      noInternetConnection: "Sin conexión a internet",
    },
    search: {
      teamOrPlayerPlaceholder: "Buscar un equipo o jugador...",
    },
    affiliate: {
      claimYourOffer: "Reclama tu oferta de {{operator}}",
    },
    advancedTools: {
      startingLineups: "Alineaciones iniciales",
      startingPitchers: "Lanzadores abridores",
      weatherReport: "Reporte del clima",
    },
    toasts: {
      addedToMyPicks: "Agregado a Mis Picks",
      alreadyInMyPicks: "Ya está en Mis Picks",
    },
    hints: {
      goToMyPicks: "Ve a Mis Picks para hacer tu apuesta.",
    },
    profile: {
      completeYourProfile: "Completa tu perfil",
    },
    bonuses: "Bonos",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "eFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "G",
      "GA": "GC",
      "GK": "GK",
      "GP": "PJ",
      "OPP": "RIV",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "D",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PIM",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "ROJ",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "SOT",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "T",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "REB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "V",
      "WHIP": "WHIP",
      "WINS": "V",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "AMA",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Rendimiento en carrera (por partido)",
          "Distance covered": "Distancia recorrida",
          "Number of sprints": "Número de sprints",
          "Attacking": "Ataque",
          "Goals per game": "Goles por partido",
          "Penalty goals": "Goles de penalti",
          "Free kick goals": "Goles de tiro libre",
          "Goals from inside the box": "Goles dentro del área",
          "Goals from outside the box": "Goles fuera del área",
          "Left-footed goals": "Goles con la izquierda",
          "Right-footed goals": "Goles con la derecha",
          "Headed goals": "Goles de cabeza",
          "Big chances per game": "Ocasiones claras por partido",
          "Big chances missed per game": "Ocas. claras falladas por partido",
          "Total shots per game": "Total totales por partido",
          "Shots on target per game": "Tiros a puerta por partido",
          "Shots off target per game": "Tiros fuera por partido",
          "Blocked shots per game": "Tiros bloqueados por partido",
          "Succ. dribbles per game": "Regates complet. por partido",
          "Corners per game": "Córneres por partido",
          "Free kicks per game": "Tiros libres por partido",
          "Hit woodwork": "Tiros al palo",
          "Counter attacks": "Contraataques",
          "Passes": "Pases",
          "Ball possession": "Posesión de balón",
          "Accurate passes": "Pases precisos",
          "Acc. own half": "Acert. en campo propio",
          "Acc. opposition half": "Acert. en campo contrario",
          "Acc. long balls": "Comp. balones largos",
          "Acc. crosses": "Pases acertados",
          "Defending": "Defensa",
          "Clean sheets": "Porterías a cero",
          "Goals conceded per game": "Goles encajados por partido",
          "Tackles per game": "Entradas por partido",
          "Interceptions per game": "Intercepciones por partido",
          "Clearances per game": "Despejes por partido",
          "Saves per game": "Salvadas por juego",
          "Balls recovered per game": "Balones recuperados por partido",
          "Errors leading to shot": "Errores que llevan a disparo",
          "Errors leading to goal": "Errores que llevan a gol",
          "Penalties committed": "Penaltis cometidos",
          "Penalty goals conceded": "Goles de penalti concedidos",
          "Clearance off line": "Despejes en la línea de gol",
          "Last man tackle": "Entrada como último hombre",
          "Other": "Otros",
          "Duels won per game": "Duelos ganados por partido",
          "Ground duels won": "Duelos en el suelo ganados",
          "Aerial duels won": "Duelos aéreos ganados",
          "Possession lost per game": "Posesión perdida por partido",
          "Throw-ins per game": "Saques de banda por partido",
          "Goal kicks per game": "Saques de puerta por partido",
          "Offsides per game": "Fueras de juego por partido",
          "Fouls per game": "Faltas por partido",
          "Yellow cards per game": "Tarjetas amarillas por partido",
          "Red cards": "Tarjetas rojas"
        },
        "player": {
          "Matches": "Partidos",
          "Appearances": "Partidos jugados",
          "Started": "Comenzado",
          "Minutes per game": "Minutos por partido",
          "Total minutes played": "Total de minutos jugados",
          "Team of the week": "Equipo de la Semana",
          "Running performance (per 90)": "Rendimiento en carrera (por 90)",
          "Top speed": "Velocidad máxima",
          "Goals": "Goles",
          "Expected goals (xG)": "Goles esperados (xG)",
          "Scoring frequency (in minutes)": "Frecuencia de goles (en minutos)",
          "Total shots": "Tiros totales",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Ocas. claras falladas",
          "Goal conversion": "Eficacia de los tiros",
          "Penalty conversion": "Penaltis anotados",
          "Free kick conversion": "Efectividad en los tiros libres",
          "Penalty won": "Penalti provocado",
          "Passing": "Pases",
          "Assists": "Asistencias",
          "Expected assists (xA)": "Asistencias esperadas (xA)",
          "Touches": "Toques",
          "Big chances created": "Ocas. claras creadas",
          "Key passes": "Pases clave",
          "Long balls (accurate)": "Pases largos (acertados)",
          "Accurate chip passes": "Pases de vaselina precisos",
          "Interceptions": "Intercepciones",
          "Possession won (final third)": "Posesiones ganadas (tercio final)",
          "Dribbled past per game": "Regateado por partido",
          "Other (per game)": "Otro (por partido)",
          "Succ. dribbles": "Regates completados",
          "Total duels won": "Duelos totales ganados",
          "Possession lost": "Posesiones perdidas",
          "Was fouled": "Recibió falta",
          "Offsides": "Fueras de juego",
          "Cards": "Tarjetas",
          "Yellow": "Amarilla",
          "Red (2 yellows)": "Roja (2 amarillas)",
          "Red": "Roja"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Resumen del partido",
          "Shots on goal": "Tiros a puerta",
          "Penalties": "Sanciones",
          "Penalty minutes": "Minutos de expulsión",
          "Hits": "Golpes",
          "Blocked shots": "Tiros bloqueados",
          "Takeaways": "Robos",
          "Giveaways": "Pérdidas",
          "Empty net goals": "Goles a puerta vacía",
          "Power play %": "Superioridad numérica (%)",
          "Faceoffs won": "Saques neutrales ganados",
          "Game Shotmap": "Mapa de disparos del partido",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Equipos especiales",
          "Power play shot %": "Tiros en superioridad (%)",
          "Shorthanded shot %": "Tiros en inferioridad (%)",
          "Even strength shot %": "Tiros en igualdad (%)",
          "Power play faceoffs": "Saques en superioridad numérica",
          "Shorthanded faceoffs": "Saques en inferioridad numérica",
          "Even strength faceoffs": "Saques en igualdad",
          "5v4 conversion": "Conversión en 5 contra 4",
          "Shots": "Tiros",
          "Wrist": "Muñeca",
          "Slap": "Golpe",
          "Backhand": "Revés",
          "Tip": "Desviación",
          "Snap": "Tiro rápido",
          "Advanced stats": "Estadísticas avanzadas",
          "Corsi %": "Corsi (%)",
          "Fenwick %": "Fenwick (%)",
          "Average shot distance": "Distancia media de tiro"
        },
        "player": {
          "Overall": "General",
          "Games played": "Partidos jugados",
          "Average time on ice": "Promedio de tiempo de hielo",
          "Goals": "Goles",
          "Assists": "Asistencias",
          "Points": "Puntos",
          "Plus/minus": "Plus/minus",
          "Shots on goal": "Tiros a puerta",
          "Shooting percentage": "Porcentaje de tiros",
          "Game winning goals": "Goles ganadores",
          "Overtime goals": "Goles en prorroga",
          "Defensive": "En defensiva",
          "Penalty minutes": "Minutos de expulsión",
          "Blocked shots": "Tiros bloqueados",
          "Hits": "Golpeos",
          "Power play": "Superioridad numérica",
          "Powerplay average time on ice": "Promedio de tiempo en hielo en superioridad numérica",
          "Power play goals": "Goles en superioridad",
          "Power play assists": "Asistencias en superioridad",
          "Power play points": "Puntos en superioridad",
          "Shorthanded": "Inferioridad numérica",
          "Shorthanded average time on ice": "Promedio de tiempo en hielo en inferioridad numérica",
          "Shorthanded goals": "Goles en inferioridad",
          "Shorthanded assists": "Asistencias en inferioridad numérica",
          "Shorthanded points": "Puntos en cola corta",
          "Shorthanded shots": "Tiros en inferioridad numérica",
          "Even-strength": "Igualdad",
          "Even strength average time on ice": "Promedio de tiempo en hielo en igualdad",
          "Faceoff": "Saque",
          "Faceoffs taken": "Saque realizados",
          "Faceoffs won": "Saques ganados",
          "Faceoff win percentage": "Porcentaje de saques ganados"
        }
      },
      "baseball": {
        "AB": "En bateo",
        "R": "Carreras",
        "H": "Hits",
        "RBI": "Carreras impulsadas",
        "HR": "Jonrones",
        "BB": "Bases por bolas",
        "K": "Ponches",
        "AVG": "Promedio de bateo",
        "OBP": "Porcentaje en base",
        "SLG": "Porcentaje de slugging",
        "OPS": "En base más slugging",
        "IP": "Entradas lanzadas",
        "ERA": "Promedio de carrera limpia permitida",
        "H_ALLOWED": "Hits permitidos",
        "R_ALLOWED": "Carreras permitidas",
        "ER": "Carreras limpias",
        "BB_ALLOWED": "Bases por bolas permitidas",
        "HR_ALLOWED": "Jonrones permitidos",
        "NP": "Número de lanzamientos",
        "STR": "Strikes lanzados",
        "WHIP": "Bases por bolas y hits por entrada lanzada",
        "PO": "Putouts",
        "A": "Asistencias",
        "E": "Errores",
        "DP": "Doble plays",
        "CS": "Atrapado robando",
        "SB": "Bases robadas permitidas"
      },
      "basketball": {
        "team": {
          "Free throws": "Tiros libres",
          "2 pointers": "Canastas de 2 puntos",
          "3 pointers": "Canastas de 3 puntos",
          "Field goals": "Tiros de campo",
          "Rebounds": "Rebotes",
          "Defensive rebounds": "Rebotes defensivos",
          "Offensive rebounds": "Rebotes ofensivos",
          "Assists": "Asistencias",
          "Turnovers": "Pérdidas de balón",
          "Steals": "Robos",
          "Blocks": "Tapones",
          "Fouls": "Faltas",
          "Max points in a row": "Máxima racha de puntos",
          "Time spent in lead": "Tiempo en cabeza",
          "Biggest lead": "Máxima diferencia"
        },
        "player": {
          "MIN": "Minutos jugados",
          "PTS": "Puntos",
          "REB": "Rebotes",
          "AST": "Asistencias",
          "STL": "Robos",
          "BLK": "Tapones",
          "PF": "Faltas personales",
          "TOV": "Pérdidas de balón",
          "OREB": "Rebotes ofensivos",
          "DREB": "Rebotes defensivos",
          "FG": "Tiros de campo",
          "FG%": "Goles de campo (%)",
          "FT": "Tiros libres",
          "FT%": "Tiros libres (%)",
          "3P": "Canastas de 3 puntos",
          "3P%": "Porcentaje de canastas de 3 puntos",
          "+/-": "Plus-Minus",
          "PIR": "Índice de valoración"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Ofensa",
          "TD": "Touchdowns",
          "FG": "Tiros de campo",
          "NET YDS": "Yardas totales",
          "TO": "Pérdidas de balón",
          "RZ%": "Eficiencia en la zona roja",
          "1D": "Primeros downs",
          "3D%": "Eficiencia en tercer down",
          "Passing": "Pases",
          "PASS YDS": "Yardas netas de pases",
          "PASS TD": "Pases de touchdown",
          "INT THROWN": "Interceptaciones lanzadas",
          "PASS YDS/ATT": "Media de yardas de pases por acarreo",
          "PASS RZ ATT": "Acarreos de pase en zona roja",
          "Rushing": "A la carrera",
          "RUSH ATT": "Intentos de carrera",
          "RUSH YDS": "Yardas por tierra",
          "RUSH YDS/ATT": "Media de yardas de carrera por acarreo",
          "Rushing 1st downs": "1er intento de carrera",
          "RUSH RZ ATT": "Acarreos de carrera en zona roja",
          "Other": "Otros",
          "FUML": "Balones sueltos perdidos"
        },
        "player": {
          "PASS COMP": "Completos",
          "PASS ATT": "Intentos",
          "PASS YDS": "Yardas que pasan",
          "PASS TD": "Pases de touchdown",
          "INT": "Pases interceptados",
          "PASS YDS/ATT": "Yardas de pase por intento",
          "PASS RTG": "Índice de pasador",
          "RUSH ATT": "Intentos de carrera",
          "RUSH YDS": "Yardas por tierra",
          "RUSH TD": "Touchdown por tierra",
          "RUSH YDS/ATT": "Yardas por tierra por intento",
          "RUSH LONG": "Carrera más larga",
          "REC TGT": "Objetivos de la recepción",
          "REC": "Recepciones",
          "REC YDS": "Yardas de recepcion",
          "REC TD": "Touchdown de recepcion",
          "REC YDS/REC": "Yardas por recepcion",
          "TCK": "Placajes combinados",
          "SK": "Sacks",
          "FUML": "Balones sueltos perdidos",
          "FGM": "Tiros de campo convertidos",
          "XPM": "Puntos extras hechos",
          "PTS": "Puntos totales"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Posesión de balón",
          "Passes": "Pases",
          "Tries": "Ensayos",
          "Try assists": "Asistencias para ensayos",
          "Conversions": "Conversión",
          "Carries": "Llevar el balón",
          "Clean breaks": "Avances limpios",
          "Penalty goals": "Goles de penalti",
          "Drop goals": "Gol de campo",
          "Scrums": "Melé",
          "Lineouts": "Fuera de línea",
          "Turnovers": "Pérdidas de balón",
          "Turnovers won": "Balones recuperados",
          "Meters run": "Metros recorridos",
          "Offloads": "Pases después del placaje",
          "Tackles": "Entradas",
          "Tackles missed": "Entradas falladas",
          "Penalties conceded": "Penales concedidos",
          "Red cards": "Tarjetas rojas",
          "Yellow cards": "Tarjetas amarillas"
        },
        "player": {
          "PTS": "Puntos",
          "TRY": "Ensayos",
          "TKL": "Entradas",
          "PG": "Goles de penalti",
          "PAS": "Pases",
          "CAR": "Llevar el balón",
          "CB": "Avances limpios",
          "DG": "Gol de campo",
          "MR": "Metros recorridos",
          "OFF": "Pases después del placaje",
          "TM": "Entradas falladas",
          "TA": "Asistencias para ensayos",
          "TW": "Balones recuperados"
        }
      }
    },
    positions: {
      goalies: "Porteros",
      skaters: "Patinadores",
      pitchers: "Lanzadores",
      hitters: "Bateadores",
      forwards: "Delanteros",
      midfielders: "Mediocampistas",
      defenders: "Defensores",
      outfielders: "Jugadores de campo",
      players: "Jugadores",
    },
    filters: {
      titles: {
        lineType: "Tipo de línea",
        game: "Partido",
        outcome: "M/M",
        betType: "Tipo de apuesta",
        trendType: "Tipo de tendencia",
        signals: "Señales",
        season: "Temporada",
        team: "Equipo",
        minOdds: "Cuota mínima",
        timeframe: "Periodo",
      },
      plurals: {
        lineType: "Tipos de línea",
        game: "Partidos",
        outcome: "Resultados",
        betType: "Tipos de apuesta",
        trendType: "Tipos de tendencia",
        signals: "Señales",
        season: "Temporadas",
        team: "Equipos",
      },
      options: {
        game: {
          all: "Todos los partidos",
          byGame: "Por partido",
        },
        team: {
          all: "Todos los equipos",
        },
        lineType: {
          main: "Líneas principales",
          alternate: "Líneas alternas",
        },
        outcome: {
          all: "Más+Menos",
          over: "Más de",
          under: "Menos de",
          yes: "Sí",
          no: "No",
          cover: "Cubre",
        },
        betType: {
          all: "Todos los tipos de apuesta",
        },
        minOdds: {
          all: "Todas las cuotas",
        },
        timeframe: {
          season: "Temporada",
          playoffs: "Playoffs",
          headToHead: "Cara a cara",
          last5: "Últimos 5",
          last10: "Últimos 10",
          last20: "Últimos 20",
          last30: "Últimos 30",
        },
        splits: {
          all: "Local+Visitante",
          home: "Local",
          away: "Visitante",
        },
        trendType: {
          player: "Jugador",
          team: "Equipo",
        },
        qualifier: {
          averageStats: "Por partido",
          cumulativeStats: "Totales",
        },
        signals: {
          allSignals: "Todas las señales",
          recentForm: "Forma reciente",
          headToHead: "Cara a cara",
          homeAwaySplits: "Local/visitante",
          opponentRank: "Ranking del rival",
          injuryImpact: "Impacto de lesiones",
          starter: "Titular",
          weather: "Clima",
          startingPitcher: "Lanzador abridor",
        },
      },
    },
    empty: {
      checkBackLater: "Vuelve más tarde.",
      pendingOdds: {
        title: "Cuotas pendientes",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Goles",
    ANYTIME_TOUCHDOWN: "Touchdown en cualquier momento",
    ANYTIME_TOUCHDOWN_1Q: "Touchdown en cualquier momento 1C",
    ANYTIME_TRY_SCORER: "Anotador de ensayo en cualquier momento",
    ASSISTS: "Asistencias",
    ASSISTS_1Q: "Asistencias 1C",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Tiros bloqueados",
    BLOCKS: "Tapones",
    BOTH_TEAMS_TO_SCORE: "Ambos equipos anotan",
    CARDS: "Tarjetas",
    CORNERS: "Córners del equipo",
    DISPOSALS: "Posesiones",
    DOUBLE_CHANCE: "Doble oportunidad",
    DOUBLE_DOUBLE: "Doble-doble",
    EXTRA_POINTS_MADE: "Puntos extra convertidos",
    FIELD_GOALS_MADE: "Tiros de campo convertidos",
    GAME_TOTAL: "Total del partido",
    GAME_TOTAL_1H: "Total del partido 1T",
    GAME_TOTAL_1Q: "Total del partido 1C",
    GAME_TOTAL_2H: "Total del partido 2T",
    GAME_TOTAL_CARDS: "Total de tarjetas del partido",
    GAME_TOTAL_FIRST_5_INNINGS: "Total del partido en las primeras 5 entradas",
    GOAL_OR_ASSIST: "Gol o asistencia",
    GOALS: "Goles",
    GOALS_ALLOWED: "Goles recibidos",
    HITTER_DOUBLES: "Dobles",
    HITTER_HITS: "Hits",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "HR",
    HITTER_RUNS: "Carreras",
    HITTER_RUNS_BATTED_IN: "Carreras impulsadas",
    HITTER_SINGLES: "Sencillos",
    HITTER_STOLEN_BASES: "Bases robadas",
    HITTER_TOTAL_BASES: "Bases totales",
    HITTER_TRIPLES: "Triples",
    INTERCEPTIONS: "Intercepciones",
    KICKING_POINTS: "Puntos de patada",
    MARKS: "Marcas",
    MONEY_LINE: "Ganador",
    MONEY_LINE_1H: "Ganador 1T",
    MONEY_LINE_1Q: "Ganador 1C",
    MONEY_LINE_2H: "Ganador 2T",
    MONEY_LINE_FIRST_5_INNINGS: "Ganador en las primeras 5 entradas",
    PASSING_ATTEMPTS: "Intentos de pase",
    PASSING_COMPLETIONS: "Pases completos",
    PASSING_PLUS_RUSHING_YARDS: "Yardas por pase + carrera",
    PASSING_PLUS_RUSHING_YARDS_1Q: "Yardas por pase + carrera 1C",
    PASSING_TOUCHDOWNS: "Pases de Touchdown",
    PASSING_YARDS: "Yardas por pase",
    PASSING_YARDS_1Q: "Yardas por pase 1C",
    PITCHER_EARNED_RUNS: "Carreras limpias",
    PITCHER_HITS_ALLOWED: "Hits permitidos",
    PITCHER_OUTS: "Outs del lanzador",
    PITCHER_STRIKEOUTS: "Ponches del lanzador",
    PITCHER_WALKS_ALLOWED: "Bases por bolas permitidas",
    POINTS: "Puntos",
    POINTS_1Q: "Puntos 1C",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Puntos en power play",
    REBOUNDS: "Rebotes",
    REBOUNDS_1Q: "Rebotes 1C",
    RECEIVING_YARDS: "Yardas por recepción",
    RECEIVING_YARDS_1Q: "Yardas por recepción 1C",
    RECEPTIONS: "Recepciones",
    RUN_FIRST_INNING: "Carrera en la primera entrada",
    RUSHING_ATTEMPTS: "Intentos por carrera",
    RUSHING_PLUS_RECEIVING_YARDS: "Yardas por carrera + recepción",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "Yardas por carrera + recepción 1C",
    RUSHING_YARDS: "Yardas por carrera",
    RUSHING_YARDS_1Q: "Yardas por carrera 1C",
    SAVES: "Atajadas",
    SHOTS: "Tiros",
    SHOTS_ON_GOAL: "Tiros a portería",
    SHOTS_ON_TARGET: "Tiros a puerta",
    player: {
      SHOTS_ON_TARGET: "Tiros a puerta",
    },
    team: {
      SHOTS_ON_TARGET: "Tiros a puerta del equipo",
    },
    SHUTOUT: "Portería a cero",
    SPREAD: "Hándicap",
    SPREAD_1H: "Hándicap 1T",
    SPREAD_1Q: "Hándicap 1C",
    SPREAD_2H: "Hándicap 2T",
    SPREAD_FIRST_5_INNINGS: "Hándicap en las primeras 5 entradas",
    STEALS: "Robos",
    STEALS_PLUS_BLOCKS: "ROB+TAP",
    TACKLES: "Tacleadas",
    TEAM_TOTAL: "Total del equipo",
    TEAM_TOTAL_1H: "Total del equipo 1T",
    TEAM_TOTAL_1Q: "Total del equipo 1C",
    TEAM_TOTAL_2H: "Total del equipo 2T",
    TEAM_TOTAL_CARDS: "Total de tarjetas del equipo",
    THREE_POINTS_MADE: "Triples",
    TRIES: "Ensayos",
    TRIPLE_DOUBLE: "Triple-doble",
    TURNOVERS: "Pérdidas",
    WIN_TO_NIL: "Ganar sin recibir gol",
  },
};
